import React, { useMemo } from 'react';
import { LogFileParsedDaily } from 'c-pop-displays/Components/LogFileParsed';
import { channelFrameMediaBreakdownFetcher } from 'c-pop-displays/Lib/channelFrameMediaBreakdown';
import { isValid } from 'date-fns';

type Props = {
    id: number;
    minDate: Date;
    maxDate: Date;
    mediaNames?: string[];
    defaultGroupByMedia?: boolean;
    defaultGroupByHour?: boolean;
};

const DisplayDates: React.FC<Props> = ({
    id,
    minDate,
    maxDate,
    mediaNames,
    defaultGroupByMedia,
    defaultGroupByHour,
}) => {
    const validDates = useMemo(() => isValid(minDate) && isValid(maxDate), [minDate, maxDate]);

    const fetchData = useMemo(
        () => channelFrameMediaBreakdownFetcher(id, mediaNames ?? []),
        [id, mediaNames],
    );

    if (!validDates) return null;

    return (
        <LogFileParsedDaily
            minDate={minDate}
            maxDate={maxDate}
            chartName={`${id}-daily-totals`}
            fetchData={fetchData}
            defaultGroupByMedia={defaultGroupByMedia}
            defaultGroupByHour={defaultGroupByHour}
        />
    );
};
export default DisplayDates;
